import Vue from 'vue'
import Router from 'vue-router'
import Home from '../screens/Home'
import Login from '../screens/Login'
import FBUpload from '../screens/FBUpload'
import FBListSubmissions from '../screens/FBListSubmissions'
import ApprovedSongs from '../screens/ApprovedSongs'
import Main from '../screens/Main';
import TCPrivacy from "../screens/TCPrivacy";
import SampleList from '../screens/SampleList';
import EndUserAgreement from '@/screens/EndUserAgreement';

import { auth } from '@/config/firebaseInit'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      meta: {
        requiresAuth: false
      }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
          requiresGuest: false
        }
    },
    {
      path: '/upload',
      name: 'FBUpload',
      component: FBUpload,
      meta: {
        requiresGuest: false
      }
    },
    {
        path: '/list',
        name: 'FBListSubmissions',
        component: FBListSubmissions,
        meta: {
          requiresAuth: true
        }

      },
      {
        path: '/songs',
        name: 'ApprovedSongs',
        component: ApprovedSongs,
        meta: {
          requiresGuest: false
        }

      },
      {
          path: '/landing',
          name: 'Home',
          component: Home,
          meta: {
              requiresGuest: false
          }
      },
      {
          path: "/terms-conditions",
          name: 'Terms, Conditions & Privacy Policy',
          component: TCPrivacy,
          meta: {
              requiresGuest: false
          }
      },
      {
          path: '/samples',
          name: 'Song Samples',
          component: SampleList,
          meta: {
              requiresAuth: true
          }
      },
      {
        path: '/end-user-agreement',
        name: 'End User Agreement',
        component: EndUserAgreement,
        meta: {
          requiresAuth: false
        }
      }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !auth.currentUser) {
    return next({ path: '/login' });
  } else if (to.matched.some(record => record.meta.requiresGuest) && auth.currentUser) {
    return next({ path: '/list' });
  }
  return next();
});

export default router;
